import React, { Component } from 'react';
import { Tabs } from "@tinper/next-ui";
import { REFER_TYPE } from '../../utils/refer_context/referType';
import Table from './Table.js';
import Tree from './Tree.js';
import TreeTable from './TreeTable.js';

const { TabPane } = Tabs;

export default class TabsComponent extends Component {
    state = {
        activeKey: 'all'
    }

    onChange = (activeKey) => {
        this.setState({
            activeKey,
        });
    }

    getListComponent = () => {
        const { referType, referContext, metaData, showStopStatus, topName, newRefMeta } = this.props;
        // 根据参照类型加载不同组件
        if (REFER_TYPE.from(referType) === REFER_TYPE.TABLE || REFER_TYPE.from(referType) === REFER_TYPE.TREE_LIST) { // 表参照
            return <Table referContext={referContext} metaData={metaData} isMultiple={referContext.isMultiple} showStopStatus={showStopStatus} activeKey={this.state.activeKey} newRefMeta={newRefMeta} />
        } else if (REFER_TYPE.from(referType) === REFER_TYPE.TREE) {
            return <Tree referContext={referContext} isMultiple={referContext.isMultiple} showStopStatus={showStopStatus} />
        } else {
            return <TreeTable referContext={referContext} metaData={metaData} topName={topName} newRefMeta={newRefMeta} />
        }
    }

    getFieldId = () => {
        const { fieldid, fieldidPrefix } = this.props.referContext.props || {};
        return fieldid || fieldidPrefix;
    };

    render() {
        const view = this.getListComponent()
        const tabs = [
            { name: lang.templateByUuid('UID:P_LIB-WEB-YNF-FE_191B4C4605200012', '全部', undefined, {returnDom: true, placement: 'top'}), key: 'all' },
            // { name: '我的收藏', key: 'favorite' },
            // { name: '常用历史', key: 'history' }
        ]
        return (
            <Tabs activeKey={this.state.activeKey} onChange={this.onChange} className="ynf-refer-tabs" fieldid={`${this.getFieldId()}`}>
                {
                    tabs.map(item => {
                        return <TabPane tab={item.name} key={item.key} fieldid={`${this.getFieldId()}`}>{view}</TabPane>
                    })
                }
            </Tabs>
        )
    }
}
